import { AuthenticationErrorType, AuthorizationErrorType, SCError } from "@next-platform/packages-ts-types";
import { useTranslation } from "../../features/localization/hooks";
const { ERROR_CODE_PREFIX } = SCError || {};
// eslint-disable-next-line id-length -- param name must stay `t` so static i18n keycheck / extractors see real error:auth.* string literals
const getNonContextAuthenticationErrors = (t) => ({
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.EXTERNAL_USER_AUTHENTICATION_FAILED}`]: t("error:auth.externalUserAuthenticationFailed"),
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.INVALID_OR_EXPIRED_TOKEN}`]: t("error:auth.invalidOrExpiredToken"),
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.INVALID_OR_MISSING_JWT}`]: t("error:auth.invalidOrMissingJwt"),
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.INVALID_REFRESH_TOKEN}`]: t("error:auth.invalidRefreshToken"),
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.MISSING_APPID_APIKEY}`]: t("error:auth.missingAppidApikey"),
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.MISSING_APPLICATION_ID}`]: t("error:auth.missingApplicationId"),
    [`${ERROR_CODE_PREFIX}-${AuthenticationErrorType.MISSING_EXTERNAL_USER_ID}`]: t("error:auth.missingExternalUserId"),
});
// eslint-disable-next-line id-length -- param name must stay `t` so static i18n keycheck / extractors see real error:auth.* string literals
const getNonContextAuthorizationErrors = (t) => ({
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.APIKEY_FOR_APPID_UNKNOWN}`]: t("error:auth.apikeyForAppidUnknown"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.INVALID_ACCESS_POLICIES_OBJECT}`]: t("error:auth.invalidAccessPoliciesObject"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.NOT_ALLOWED_TO_UPDATE_CONVERSATION}`]: t("error:auth.notAllowedToUpdateConversation"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.NOT_ALLOWED_TO_VIEW_RESOURCE}`]: t("error:auth.notAllowedToViewResource"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.RENEW_TOKEN_NOT_ALLOWED}`]: t("error:auth.renewTokenNotAllowed"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.RESOURCE_ACCESS_NOT_ALLOWED}`]: t("error:auth.resourceAccessNotAllowed"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.RESOURCE_ACCESS_POLICY_UNDEFINED}`]: t("error:auth.resourceAccessPolicyUndefined"),
    [`${ERROR_CODE_PREFIX}-${AuthorizationErrorType.UNAUTHORIZED}`]: t("error:auth.unauthorized"),
});
// eslint-disable-next-line import/prefer-default-export -- named hook export matches package barrel
export function useAuthErrors() {
    const { t } = useTranslation();
    const nonContextAuthenticationErrors = getNonContextAuthenticationErrors(t);
    const nonContextAuthorizationErrors = getNonContextAuthorizationErrors(t);
    const getMessage = ({ errorCode, fallbackMessage, skipDefaultMessage }) => {
        const nonContextError = nonContextAuthenticationErrors[errorCode] || nonContextAuthorizationErrors[errorCode];
        if (nonContextError) {
            return nonContextError;
        }
        if (skipDefaultMessage)
            return "";
        return fallbackMessage || t("error:fallbackError");
    };
    return {
        getMessage,
    };
}
